// Remembers a circle invite code across the whole sign-up journey, so a friend who opens
// an invite link WITHOUT an account still lands in the circle after they register, verify
// their email, and sign in — even if that final sign-in happens in a fresh tab (from the
// verification email) that lost the original /join/<code> route. Mirrors the Android app's
// pending-invite stash. Cleared once the join succeeds or the code proves invalid.
const KEY = 'ss_pending_join';

export const setPendingJoin = (code) => {
  try { if (code) window.localStorage.setItem(KEY, String(code).toUpperCase()); } catch { /* storage blocked */ }
};

export const getPendingJoin = () => {
  try { return window.localStorage.getItem(KEY); } catch { return null; }
};

export const clearPendingJoin = () => {
  try { window.localStorage.removeItem(KEY); } catch { /* storage blocked */ }
};
